<template>
  <SleepTargets
    v-model='sleepTargetModal'
    title='Start your sleep coaching plan'
    button='Generate my plan'
    text='To build the best plan for you, confirm your what time you want to wake up.'
    :disableClose='true'
    @save-function="goToNext()"
  >
  </SleepTargets>
</template>

<script>
import SleepTargets from '@/components/modals/SleepTargets'
import User from '@/models/user'

export default {
  name: 'PlanTargets',
  components: {
    SleepTargets,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      sleepTargetModal: true,
    }
  },
  beforeMount() {
  },
  watch: {
  },
  methods: {
    async goToNext() {
      const user = await User.getCurrentUser()
      await user.startPlan()
      this.$router.push('/plan/start')
    },
  },
  computed: {
  }
}
</script>